import { render, staticRenderFns } from "./UploadStep.vue?vue&type=template&id=290c1fa4"
import script from "./UploadStep.vue?vue&type=script&lang=js"
export * from "./UploadStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports